export const allowedFileTypes = [
  '.csv',
  '.doc',
  '.docx',
  '.eml',
  '.fax',
  '.html',
  '.img',
  '.jpeg',
  '.jpg',
  '.json',
  '.mht',
  '.msg',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.rtf',
  '.tif',
  '.txt',
  '.xls',
  '.xlsx',
  '.zip',
  '.xlsm',
];
